const cx = (classNames: { [key: string]: any }): string => {
    return Object.keys(classNames).reduce(
        (classList, className) => (Boolean(classNames[className]) === true ? `${classList} ${className}` : classList),
        ''
    )
}

export default cx
